import { combineReducers, Reducer } from 'redux'
import { ApexCash, ApexAccounts, ApexAuth, ApexProviders } from 'apex-ui-services'
import { apexMenuReducers } from 'apex-online-menu'
import { legitReducers } from 'apex-legit-service'
import { countryReducer } from '../reducers'

export const rootReducer = combineReducers({
  ...ApexCash.achRel.reducers,
  ...ApexCash.amountAvailable.reducers,
  ...ApexCash.achTransfers.reducers,
  ...ApexAccounts.accounts.reducers,
  ...ApexCash.iraConstraints.reducers,
  ...ApexCash.transfers.reducers,
  ...ApexAuth.authorization.reducers,
  ...ApexAuth.legacyUrl.reducers,
  ...ApexAuth.loginSso.reducers,
  ...ApexAuth.loginType.reducers,
  ...(legitReducers as Record<string, Reducer>),
  ...ApexProviders.margins.reducers,
  ...(apexMenuReducers as Record<string, Reducer>),
  countryReducer
})

export default rootReducer
